import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin } from 'lucide-react';
import { useBooking } from '../hooks/useBooking';
const LOCATIONS = ['Bali'];
interface LocationSearchProps {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}
export function LocationSearch({
  isOpen,
  onOpen,
  onClose
}: LocationSearchProps) {
  const {
    location,
    setLocation
  } = useBooking();
  const [searchTerm, setSearchTerm] = useState(location);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setSearchTerm(location);
  }, [location]);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);
  const filteredLocations = LOCATIONS.filter(loc => loc.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="relative flex-[1.2] min-w-0" ref={containerRef} data-id="element-208">
      <div className="p-3 md:px-5 hover:bg-gray-50 rounded-xl transition-colors cursor-pointer group h-full flex flex-col justify-center" onClick={onOpen} data-id="element-209">
        <label className="block text-xs font-semibold text-gray-800 mb-1 uppercase tracking-wider cursor-pointer" data-id="element-210">
          Location
        </label>
        <div className="flex items-center text-gray-500 group-hover:text-gray-900 min-w-0" data-id="element-211">
          <MapPin className="w-4 h-4 mr-2 text-luxury-blue shrink-0" data-id="element-212" />
          <input type="text" placeholder="Where to?" value={searchTerm} onChange={e => {
          setSearchTerm(e.target.value);
          if (!isOpen) onOpen();
        }} className="w-full bg-transparent border-none focus:ring-0 p-0 text-sm font-medium placeholder:text-gray-400 placeholder:italic outline-none min-w-0 truncate" data-id="element-213" />
        </div>
      </div>

      <AnimatePresence data-id="element-214">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} transition={{
        duration: 0.2
      }} className="absolute top-full left-0 mt-4 w-full md:w-80 bg-white rounded-2xl shadow-float border border-gray-100 py-2 z-50 overflow-hidden" data-id="element-215">
            {filteredLocations.length > 0 ? <ul className="max-h-64 overflow-y-auto" data-id="element-216">
                {filteredLocations.map(loc => <li key={loc} onClick={() => {
            setLocation(loc);
            setSearchTerm(loc);
            onClose();
          }} className="px-4 py-3 hover:bg-gray-50 cursor-pointer flex items-center text-sm font-medium text-gray-700 transition-colors" data-id="element-217">
                    <MapPin className="w-4 h-4 mr-3 text-gray-400" data-id="element-218" />
                    {loc}
                  </li>)}
              </ul> : <div className="px-4 py-4 text-sm text-gray-500 text-center italic" data-id="element-219">
                No locations found
              </div>}
          </motion.div>}
      </AnimatePresence>
    </div>;
}